/**
 * Helper para enviar notificaciones a la API externa de VML
 */

const API_URL =
  "https://vmltechnologies.com/VML.FleetManager.Backend/public/api/pwa/momentos";

/**
 * Envía una notificación a la API externa
 * @param {Object} notificacion - Objeto con los datos de la notificación
 * @param {string} notificacion.caso - Número de caso
 * @param {string} notificacion.cedula - Cédula del usuario
 * @param {string} notificacion.momento - Momento/tipo de notificación
 * @param {string} notificacion.fechahora - Fecha y hora en formato YYYY-MM-DD HH:mm:ss
 * @returns {Promise<Object>} Respuesta de la API
 */
export async function enviarNotificacionAPI(notificacion) {
  try {
    const payload = {
      caso: notificacion.caso || "",
      cedula: notificacion.cedula || "",
      momento: notificacion.momento || "",
      fechahora: notificacion.fechahora || "",
    };

    const response = await fetch(API_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(
        `Error al enviar notificación a la API: ${response.status} ${response.statusText}`
      );
    }

    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    console.error("Error al enviar notificación a la API externa:", error);
    return { success: false, error: error.message };
  }
}
